import { render } from "./LoginUnknown.vue?vue&type=template&id=4405bc1e"
import script from "./LoginUnknown.vue?vue&type=script&lang=js"
export * from "./LoginUnknown.vue?vue&type=script&lang=js"
script.render = render

export default script